import BrainboxPort from '../lib/brainbox_port.js'
import { hasFeature } from '../lib/auth_state.js'
import { watchEntityIcon } from '../lib/entity_icons.js'

const iconDeps = {
  request: (kind, id, size) => BrainboxPort.getEntityIcon({ kind, id, size }),
  enabled: () => hasFeature('entityIcon')
}

/**
 * EntityIcon: a Space, Group or App icon (`entity_icon/1`).
 *
 * The server renders a fallback (a circle in the entity's colour with its
 * initial) and an empty `<img>`; once the element is on screen this hook asks
 * the extension for the icon by `data-kind` / `data-id` and sets `src` on the
 * image itself, so the data URL never reaches the server. An icon the page
 * already has is shown at once. It owns the element (`phx-update="ignore"`), so a
 * re-render only changes its data attributes, which `updated()` reapplies.
 */
const EntityIcon = {
  mounted () {
    this.apply()
  },

  updated () {
    this.apply()
  },

  destroyed () {
    this.stopIcon?.()
  },

  apply () {
    const { kind, id, color, initial } = this.el.dataset
    const fallback = this.el.querySelector('[data-entity-icon-fallback]')
    const img = this.el.querySelector('img')
    if (!fallback || !img) { return }

    // Colour and initial follow a renamed or recoloured entity
    fallback.textContent = initial || ''
    fallback.style.backgroundColor = color || ''

    const key = `${kind}:${id}`
    if (this.key === key) { return }
    this.key = key
    this.stopIcon?.()
    this.show(fallback, img, null)
    this.stopIcon = watchEntityIcon(this.el, kind, id, iconDeps, (dataUrl) => {
      this.show(fallback, img, dataUrl)
    })
  },

  show (fallback, img, dataUrl) {
    if (dataUrl) {
      img.src = dataUrl
      img.hidden = false
      fallback.hidden = true
    } else {
      img.removeAttribute('src')
      img.hidden = true
      fallback.hidden = false
    }
  }
}

export default EntityIcon
